import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityVariation } from "../../entity/EntityVariation";

export class DtoVariationsPutReq extends EntityVariation {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_variation_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
